import React, { useState, useEffect } from "react";
import { fetchMiPerfil, actualizarPerfil } from "../services/api";
import { getUserData, setUserData, logout } from "../services/auth";

function MiPerfil() {
  const [form, setForm] = useState({
    nombre: "", apellido: "", rut: "", email: "", telefono: "",
  });
  const [loading,   setLoading]   = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [msg,       setMsg]       = useState("");
  const [error,     setError]     = useState("");

  useEffect(() => {
    // Fuente primaria: localStorage
    const ud = getUserData();
    if (ud) {
      setForm({
        nombre:   ud.nombre   || "",
        apellido: ud.apellido || "",
        rut:      ud.rut      || "",
        email:    ud.email    || "",
        telefono: ud.telefono || "",
      });
      setLoading(false);
    }
    // Siempre intentar desde API para tener datos frescos
    fetchMiPerfil()
      .then(res => {
        const u = res.data || {};
        setForm({
          nombre:   u.nombre   || "",
          apellido: u.apellido || "",
          rut:      u.rut      || "",
          email:    u.email    || "",
          telefono: u.telefono || "",
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleCampo = (e) =>
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGuardando(true);
    setMsg(""); setError("");
    try {
      const { nombre, apellido, email, telefono } = form;
      const emailAnterior = (getUserData() || {}).email;
      await actualizarPerfil({ nombre, apellido, email, telefono });
      // Sincronizar localStorage
      const ud = getUserData() || {};
      setUserData({ ...ud, nombre, apellido, email, telefono });

      const emailCambio = email !== emailAnterior;
      if (emailCambio) {
        // El token JWT fue generado con el email anterior — ya no es válido.
        // Hay que cerrar sesión para que el usuario obtenga un token nuevo.
        setMsg("Email actualizado. Tu sesión ha expirado. Inicia sesión nuevamente...");
        setTimeout(logout, 2500);
      } else {
        setMsg("Datos actualizados correctamente.");
      }
    } catch (err) {
      setError(err.response?.data?.error || "Error al actualizar los datos.");
    } finally {
      setGuardando(false);
    }
  };

  if (loading) return <p style={{ textAlign: "center", marginTop: 40 }}>Cargando...</p>;

  return (
    <div style={st.contenedor}>
      <h2>👤 Mi Perfil</h2>

      {msg   && <p style={{ color: "green", marginBottom: 8 }}>{msg}</p>}
      {error && <p style={{ color: "red",   marginBottom: 8 }}>{error}</p>}

      <form onSubmit={handleSubmit} style={st.form}>
        <fieldset style={st.fieldset}>
          <legend style={st.legend}>Datos personales</legend>

          <div style={st.fila}>
            <Campo label="Nombre *" name="nombre" value={form.nombre}
              onChange={handleCampo} required />
            <Campo label="Apellido *" name="apellido" value={form.apellido}
              onChange={handleCampo} required />
          </div>

          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 4, marginTop: 10 }}>
            <label style={st.label}>RUT (no editable)</label>
            <input
              value={form.rut} readOnly
              style={{ ...st.input, backgroundColor: "#f5f5f5", color: "#888", cursor: "not-allowed" }}
            />
          </div>

          <div style={{ ...st.fila, marginTop: 10 }}>
            <Campo label="Email *" name="email" type="email" value={form.email}
              onChange={handleCampo} required />
            <Campo label="Teléfono *" name="telefono" type="tel" value={form.telefono}
              onChange={handleCampo} required />
          </div>
        </fieldset>

        <button type="submit" style={st.btnGuardar} disabled={guardando}>
          {guardando ? "Guardando..." : "💾 Guardar cambios"}
        </button>
      </form>
    </div>
  );
}

function Campo({ label, name, type = "text", value, onChange, required }) {
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={{ fontSize: 12, color: "#555", fontWeight: 600 }}>{label}</label>
      <input
        name={name} type={type} value={value} onChange={onChange} required={required}
        style={{ padding: "8px 10px", borderRadius: 4, border: "1px solid #ccc", width: "100%", boxSizing: "border-box" }}
      />
    </div>
  );
}

const st = {
  contenedor: { maxWidth: 560, margin: "40px auto", padding: "0 16px" },
  form:      { display: "flex", flexDirection: "column", gap: 20 },
  fieldset:  { border: "1px solid #ddd", borderRadius: 8, padding: "16px 20px" },
  legend:    { fontWeight: "bold", padding: "0 8px" },
  fila:      { display: "flex", gap: 16 },
  label:     { fontSize: 12, color: "#555", fontWeight: 600 },
  input:     { padding: "8px 10px", borderRadius: 4, border: "1px solid #ccc", width: "100%", boxSizing: "border-box" },
  btnGuardar:{
    padding: "12px 0", backgroundColor: "#1a1a2e", color: "#fff",
    border: "none", borderRadius: 8, fontSize: 16, cursor: "pointer",
  },
};

export default MiPerfil;
